<template>
  <div class="vacancies-tab" v-if="titleMetaData">
    <component :is="`style`">
      .vacancy-stages { height: calc(100vh - {{ headerHeight }}px); }
    </component>
    <div class="header" ref="header">
      <div class="header__buttons--top">
        <Button
          hasLeftIcon
          buttonColor="white"
          srcColor="grey"
          :iconSrc="titleIconScr"
          :buttonText="titleButtonText"
          :iconColor="titleIconColor"
          class="header__button"
          buttonSize="big"
          @click="closePanel"
        />
        <p class="header-title__text header__text">{{ titleButtonText }}</p>
        <div v-if="titleSecondary" class="header__secondary">
          <Picture
            :url="titleSecondaryIcon ? titleSecondaryIcon : ''"
            class="header__image"
          />
          <p class="header__text">{{ titleSecondaryText }}</p>
        </div>
      </div>
      <Subpanel
        v-if="titleTabs"
        :tabs="titleTabs"
        module="RightPanel"
        class="header__subpanels"
      />
      <div class="header__buttons--bottom" v-if="titleHeaderBottomButtons">
        <FormButtons
          v-for="item in titleHeaderBottomButtons"
          :key="item.id"
          :buttons_menu="[[item]]"
        />
      </div>
    </div>

    <VacancySteps v-if="mode == 'canditateStagePanel' && !loading" />
    <Vacancies v-else-if="mode == 'canditatePanel' && !loading" />
    <VacancyStages v-else-if="mode == 'vacancyPanel' && !loading" />
  </div>
</template>

<script>
import { store } from '@/store';
import Vacancies from 'Elements/Sidebar/Vacancies';
import VacancySteps from 'Elements/Sidebar/VacancySteps';
import Button from 'Elements/Button/Button';
import FormButtons from 'Elements/Form/FormButtons';
import VacancyStages from 'Elements/Sidebar/VacancyStages';
import Subpanel from 'Elements/Subpanel/Subpanel';
import Picture from 'Elements/Picture/Picture';
export default {
  data() {
    return {
      currentVacancyId: '',
      headerHeight: 0
    };
  },
  created() {
    if (!localStorage.getItem('currentVacancyUserId')) {
      store.dispatch('rightPanel/getMetadata', {
        intentOrRequest: {
          url: '/index.php?module=HRPAC_SELECTION_STAGE_CANDIDATES_1&action=get_RightPanel',
          request_params: {
            vacancy_id: this.$route.params.id,
            content_type: 'vac_card'
          }
        },
        newCheck: false
      });
    }
  },
  computed: {
    titleIcon() {
      return store.state.rightPanel.panelMode == 'canditatePanel'
        ? 'MenuLeft'
        : 'FullArrowLeft';
    },
    titleIconScr() {
      return store.state.rightPanel.metadata?.title?.main[0]?.icon || '';
    },
    titleIconColor() {
      return store.state.rightPanel.metadata?.title?.main[0]?.color || '';
    },
    titleButtonText() {
      return store.state.rightPanel.metadata?.title?.main[0]?.lbl.value || '';
    },
    titleMetaData() {
      return store.state.rightPanel.metadata?.title || null;
    },
    titleSecondary() {
      return store.state.rightPanel.metadata?.title?.secondary || null;
    },
    titleHeaderBottomButtons() {
      if (store.state.rightPanel.metadata?.buttons) this.getHeaderHeight();
      return store.state.rightPanel.metadata?.buttons || null;
    },
    titleSecondaryIcon() {
      return store.state.rightPanel.metadata.title?.secondary[0]?.icon || '';
    },
    titleSecondaryText() {
      return (
        store.state.rightPanel.metadata.title?.secondary[0]?.lbl.value || ''
      );
    },
    mode() {
      return store.state.rightPanel.panelMode || '';
    },
    loading() {
      return store.state.rightPanel.loading;
    },
    titleTabs() {
      return store.state.rightPanel.metadata?.tabs?.items;
    }
  },
  methods: {
    closePanel() {
      if (this.mode == 'canditateStagePanel') {
        store.dispatch('rightPanel/getMetadata', {
          intentOrRequest:
            store.state.rightPanel.metadata.title.main[0].intents[0].request
        });
        store.commit('rightPanel/setParam', {
          name: 'panelMode',
          val: 'canditatePanel'
        });
      } else if (this.mode == 'vacancyPanel') {
        store.commit('rightPanel/setParam', {
          name: 'panelMode',
          val: null
        });
      } else {
        {
          store.commit('rightPanel/setParam', {
            name: 'panelMode',
            val: this.mode == 'canditatePanel' ? null : 'canditatePanel'
          });
        }
      }
    },
    getHeaderHeight() {
      const timer = setTimeout(() => {
        if (this.$refs.header)
          this.headerHeight = this.$refs.header.offsetHeight;
        clearTimeout(timer);
      }, 200);
    }
  },
  components: {
    Vacancies,
    VacancySteps,
    Button,
    FormButtons,
    VacancyStages,
    Subpanel,
    Picture
  }
};
</script>
<style lang="scss" scoped>
.header {
  border-bottom: 1px solid $grey8;

  &__subpanels {
    & ::v-deep .el-tabs {
      min-height: 50px;
      margin-bottom: 19px;
      padding: 0 18px 0 24px;
    }
  }

  &__buttons {
    &--top {
      display: flex;
      padding: 19px 32px 8px 8px;
      width: 100%;
      justify-content: space-between;
    }

    &--bottom {
      display: flex;
      width: fit-content;
      gap: 8px;
      margin: -3px 0 28px 24px;
    }
  }

  &__button {
    box-shadow: none !important;

    &:hover {
      background: $white;
      outline: none !important;
    }
  }

  &__secondary {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  &__image {
    filter: invert(57%) sepia(10%) saturate(567%) hue-rotate(169deg)
      brightness(90%) contrast(85%);
  }

  &__text {
    font-family: Roboto Medium;
    font-size: 16px;
    line-height: 24px;
    color: $grey64;
  }

  @media (min-width: 1313px) {
    &__button {
      display: none;
    }
  }

  @media (max-width: 1312px) {
    &-title__text {
      display: none;
    }
  }

  &-title__text {
    line-height: 40px !important;
    margin-left: 16px;
  }
}
</style>
